import { CHART_DATA_SMOOTHING } from 'src/utils/chart-data-smoothing';
import { TRANSIT_INSIGHTS_ALL_FILTER_METRICS } from '../transit-insights.constants';
import {
    buildDateRangeFromPreset,
    DATE_RANGE_PRESET_IDS,
} from '../transit-insights-date-range.constants';
import { types } from './transit-insights.types';

export const getDefaultSelectedMetrics = () => {
    const selectedMetrics = { viewAll: true };

    TRANSIT_INSIGHTS_ALL_FILTER_METRICS.forEach(({ id }) => {
        selectedMetrics[id] = true;
    });

    return selectedMetrics;
};

export const getDefaultDateRange = () =>
    buildDateRangeFromPreset(DATE_RANGE_PRESET_IDS.LAST_WEEK);

export const getDefaultTransitInsightsFilters = () => {
    const dateRange = getDefaultDateRange();

    return {
        route: '',
        direction: '',
        ...dateRange,
        selectedMetrics: getDefaultSelectedMetrics(),
        metricsPeriod: dateRange.period,
        chartDataSmoothing: CHART_DATA_SMOOTHING.DAILY,
    };
};

export const setTransitInsightsFilters = (data) => ({
    type: types.SET_TRANSIT_INSIGHTS_FILTERS,
    payload: data,
});

export const setTransitInsightsRoute = (route) => ({
    type: types.SET_TRANSIT_INSIGHTS_ROUTE,
    payload: route,
});

export const setTransitInsightsDateRange = (data) => ({
    type: types.SET_TRANSIT_INSIGHTS_DATE_RANGE,
    payload: data,
});

export const setTransitInsightsSelectedMetrics = (selectedMetrics) => ({
    type: types.SET_TRANSIT_INSIGHTS_SELECTED_METRICS,
    payload: selectedMetrics,
});

export const resetTransitInsightsFilters = (data = getDefaultTransitInsightsFilters()) => ({
    type: types.RESET_TRANSIT_INSIGHTS_FILTERS,
    payload: data,
});

export const setTransitInsightsMetricsPeriod = (period) => ({
    type: types.SET_TRANSIT_INSIGHTS_METRICS_PERIOD,
    payload: period,
});

export const setTransitInsightsChartDataSmoothing = (smoothing) => ({
    type: types.SET_TRANSIT_INSIGHTS_CHART_DATA_SMOOTHING,
    payload: smoothing,
});

export const setTransitInsightsDirection = (direction) => ({
    type: types.SET_TRANSIT_INSIGHTS_DIRECTION,
    payload: direction,
});
